// @flow
import React, { Component } from 'react';
import { Default, Mobile } from '../../../components/Responsive';
import {
  FiltersSectionDiv,
  FiltersDiv,
  FilterHeaderDownloadDiv
} from '../../../components/Filter/FilterStyles';
import SearchStatic from '../../../components/SearchStatic';
import TableFilter from '../../../components/TableFilter';
import CalendarFilter from '../../../components/CalendarFilter';
import {
  MerchantTransactionFiltersDiv,
  FiltersBackgroundDiv,
  SearchFilterDiv
} from './MerchantTransactionStyles';
import CsvFilter from '../../../components/CsvFilter';

type Props = {
  commissionStatusFilter: ?string,
  setCommissionStatusFilter: (value: string) => void,
  availableCommissionStatusesFilter: Array<{ text: string, value: string }>,
  disabled: boolean,
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  calendarStart?: string,
  calendarEnd?: string,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  setCalendarSaga: () => void,
  searchValue: string,
  setSearchFilter: (value: string) => void,
  downloadCsv: () => void,
  transactionLoading: boolean,
  windowSize: string
};

export default class MerchantTransactionFilters extends Component<Props> {
  renderSearchFilter = (mobile: boolean = false) => (
    <SearchFilterDiv rightEnd={mobile} scale={3.5}>
      <SearchStatic
        searchValue={this.props.searchValue}
        handleSearchChange={this.props.setSearchFilter}
        disabled={this.props.disabled}
        placeholder="Search..."
        hideBorderBottom
      />
    </SearchFilterDiv>
  );
  renderCommissionStatusFilter = (mobile: boolean = false) => (
    <TableFilter
      value={this.props.commissionStatusFilter}
      onChange={this.props.setCommissionStatusFilter}
      // eslint-disable-next-line react/prop-types
      options={this.props.availableCommissionStatusesFilter}
      label="Status"
      rightEnd={mobile}
      scale={2}
      noMaxWidth={mobile}
      disabled={this.props.disabled}
    />
  );
  renderDateFilter = () => (
    <CalendarFilter
      toggleCalendarFilter={this.props.toggleCalendarFilter}
      calendarFilterState={this.props.calendarFilterState}
      calendarStart={this.props.calendarStart}
      calendarEnd={this.props.calendarEnd}
      clearCalendarFilter={this.props.clearCalendarFilter}
      setCalendarStartFilter={this.props.setCalendarStartFilter}
      setCalendarEndFilter={this.props.setCalendarEndFilter}
      windowSize={this.props.windowSize}
      setCalendarSaga={this.props.setCalendarSaga}
      disabled={this.props.disabled}
    />
  );

  renderDownloadCsv = () =>
    !this.props.transactionLoading && (
      <CsvFilter
        center
        rightEnd
        filterRow
        handleCsvFilter={this.props.downloadCsv}
        disabled={this.props.disabled}
      />
    );

  render() {
    return (
      <FiltersBackgroundDiv>
        <MerchantTransactionFiltersDiv>
          <FiltersDiv>
            <Default>
              <FiltersSectionDiv>
                {this.renderSearchFilter()}
                {this.renderCommissionStatusFilter()}
                {this.renderDateFilter()}
                {this.renderDownloadCsv()}
              </FiltersSectionDiv>
            </Default>
            <Mobile>
              <FilterHeaderDownloadDiv>
                <h5>All Transactions</h5>
                {this.renderDownloadCsv()}
              </FilterHeaderDownloadDiv>
              <FiltersSectionDiv>
                {this.renderSearchFilter(true)}
              </FiltersSectionDiv>
              <FiltersSectionDiv>
                {this.renderCommissionStatusFilter()}
                {this.renderDateFilter()}
              </FiltersSectionDiv>
            </Mobile>
          </FiltersDiv>
        </MerchantTransactionFiltersDiv>
      </FiltersBackgroundDiv>
    );
  }
}
